class MainSearch extends HTMLElement {
  constructor() {
    super();
    this.trigger = this.querySelector('button');
    if (this.trigger) {
      this.trigger.addEventListener('click', this.onTriggerClick.bind(this));
    }
  }

  onTriggerClick(event) {
    // Stop this click before it can keep bubbling to document.body —
    // details-modal.js's open() attaches its own document-body 'click'
    // listener while this same click is still mid-bubble; without this it
    // catches its own triggering click on the way past and immediately
    // closes what it just opened.
    event.stopPropagation();
    this.openHeaderTakeover();
  }

  openHeaderTakeover() {
    const takeoverModal = document.querySelector('.header__search');
    if (!takeoverModal) return;

    const details = takeoverModal.querySelector('details');
    const summary = takeoverModal.querySelector('summary');
    const takeoverInput = takeoverModal.querySelector('input[type="search"]');
    if (!details || !summary || !takeoverInput || details.hasAttribute('open')) return;

    const currentQuery = this.trigger.dataset.query || '';
    if (currentQuery && takeoverInput.value !== currentQuery) {
      takeoverInput.value = currentQuery;
    }

    // Same code path as a real click on the header search icon, not a
    // reimplementation, so open/focus-trap/overflow-lock/search-takeover:open
    // all behave identically to the header entry point. details-modal.js's
    // open() already calls trapFocus(), which focuses this same input —
    // but that happens via this synthetic click, not the original trusted
    // one, and some browsers (mobile Safari especially) are stricter about
    // honoring a programmatic focus() that isn't the direct, synchronous
    // result of a real user gesture. Focus explicitly below rather than
    // relying on that implicitly working.
    summary.click();

    // Cursor at the end, not a select-all — this is "reopen my last
    // search to refine it," so typing should append, not wipe everything
    // out the moment a key is pressed.
    takeoverInput.focus();
    if (takeoverInput.value) {
      takeoverInput.setSelectionRange(takeoverInput.value.length, takeoverInput.value.length);
    }

    // Setting .value directly doesn't fire native 'input' events, so
    // PredictiveSearch's debounced listener won't have fetched results for
    // the seeded text without this.
    if (takeoverInput.value) {
      takeoverInput.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }
}

customElements.define('main-search', MainSearch);
